export default __webpack_public_path__ + "static/media/logo-light.cc679dc1.png";